// removed by extract-text-webpack-plugin
module.exports = {"popover":"CentricUI__catalogSearcher__CatalogSearchBar__popover","root":"CentricUI__catalogSearcher__CatalogSearchBar__root","suggest":"CentricUI__catalogSearcher__CatalogSearchBar__suggest","searchIcon":"CentricUI__catalogSearcher__CatalogSearchBar__searchIcon","clearIcon":"CentricUI__catalogSearcher__CatalogSearchBar__clearIcon","inputValue":"CentricUI__catalogSearcher__CatalogSearchBar__inputValue","type":"CentricUI__catalogSearcher__CatalogSearchBar__type"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/catalogSearcher/CatalogSearchBar.css
// module id = 1082
// module chunks = 10